import type { DefaultTheme } from 'styled-components';

export const getColor = (color: string) => {
    return ({theme}: {theme: DefaultTheme})=>theme.colors[color] || color
}